/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { M as Modal, d as defineCustomElement$1 } from './modal.js';

const IonModal = Modal;
const defineCustomElement = defineCustomElement$1;

export { IonModal, defineCustomElement };
